import { createSelector, createSlice, current } from '@reduxjs/toolkit';
import eventItemData from '../../public/eventitems.json';

const initialState = {
  items: [],
};

const eventItemSlice = createSlice({
  name: 'eventItem',
  initialState,
  reducers: {
    /**
     * 初期値を読み込み
     * 
     * @param {*} state 
     * @param {*} action 
     */
    loadEventItemData(state, action) {
      const payload = action.payload;

      let loadedItems = [];
      if (Array.isArray(payload)) {
        loadedItems = payload;
      } else {
        loadedItems = eventItemData || [];
      }

      const itemDefault = {
        tagName: '',
        events: []
      };

      state.items = loadedItems
        .filter(item => item && typeof item === 'object')
        .map(item => ({
          ...itemDefault,
          ...item,
          // 【重要】配列の中身もオブジェクトのみに限定
          events: Array.isArray(item.events)
            ? item.events.filter(e => e && typeof e === 'object')
            : []
        }));
    },
    addNewTag(state, action) {
      const { tagName } = action.payload;
      state.items.push({ "tagName": tagName, "events": [] });
    },
    /**
     * 既存のタグにイベントを追加
     * 
     * @param {*} state 
     * @param {*} action 
     */
    addEventToExistingTag(state, action) {
      const { tagName, event } = action.payload;
      const tag = state.items.find(item => item.tagName === tagName);
      if (tag) {
        //Object.values(event)[0].registerType = 'custom';
        tag.events.push(event);
      }
    },
    /**
     * イベントの並び順を変更
     * @param {*} state 
     * @param {*} action 
     */
    changeEventOrder(state, action) {
      const { tagName, eventKey, newIndex, events } = action.payload;
      const tag = state.items.find(item => item.tagName === tagName);
      if (tag) {
        let newEvents = [...events];
        let event = newEvents.find(item => {
          return Object.keys(item)[0] === eventKey
        });
        newEvents.splice(newEvents.indexOf(event), 1);
        newEvents.splice(newIndex, 0, event);
        tag.events = newEvents;
      }
    },
    removeEventFromExistingTag(state, action) {
      const { tagName, eventTarget, eventName } = action.payload;
      const tag = state.items.find(item => item.tagName === tagName);
      if (tag) {
        let newEvents = tag.events.filter(item => {
          return Object.keys(item)[0] !== eventName
        });
        tag.events = newEvents;
      }
    },
    modifyEventName(state, action) {
      const { tagName, eventOriginName, newEventName, eventTargetName, comment } = action.payload;
      const tag = state.items.find(item => item.tagName === tagName);
      if (tag) {

        //eventOriginNameをeventNameに更新する
        let newEvents = tag.events.map(item => {
          if (Object.keys(item)[0] === eventOriginName) {
            //item[newEventName] = item[eventOriginName];

            //item[newEventName]にitem[eventOriginName]の内容をすべてディープコピー
            let copyJson = JSON.parse(JSON.stringify(item[eventOriginName]));

            copyJson.listenerTarget = eventTargetName;
            copyJson.comment = comment;

            delete item[eventOriginName];

            item[newEventName] = copyJson;
          }
          return item;
        });
        tag.events = newEvents;
      }
    },
    /**
    * 特定のイベントに割り当てられたスクリプト配列を更新する
    * @param {*} state 
    * @param {payload: {tagName: string, eventName: string, scripts: Array}} action 
    */
    updateEventScripts(state, action) {
      const { tagName, eventName, scripts } = action.payload;
      const tag = state.items.find(item => item.tagName === tagName);
      if (tag) {
        const event = tag.events.find(e => Object.keys(e)[0] === eventName);
        if (event) {
          event[eventName].scripts = scripts;
        }
      }
    },
    /**
     * タグのイベントにスクリプトを登録
     * @param {*} state 
     * @param {*} action 
     */
    addScriptToExistingTag(state, action) {
      const { tagName, templateId, eventName, scriptName } = action.payload;
      const tag = state.items.find(item => item.tagName === tagName);

      if (tag) {
        // イベントを名前で直接探す
        const eventObject = tag.events.find(e => Object.keys(e)[0] === eventName);

        // イベントが見つかれば、そのscripts配列に直接pushする
        if (eventObject) {
          eventObject[eventName].scripts.push({ "templateId": templateId, "scriptName": scriptName });
        }
      }
    },
    deleteEventScript(state, action) {
      const { tagName, templateId, eventName, scriptName } = action.payload;
      const tag = state.items.find(item => item.tagName === tagName);
      if (tag) {
        let newEvents = tag.events.map(item => {

          if (Object.keys(item)[0] === eventName) {
            item[eventName].scripts = item[eventName].scripts.filter(item => !(item.templateId === templateId && item.scriptName === scriptName));
          }
          return item;
        });
        tag.events = newEvents;
      }
    },
    /**
     * テンプレートIDが一致する全てのイベントを削除
     * @param {*} state 
     * @param {*} action 
     */
    deleteAllEventScript(state, action) {
      const { templateId } = action.payload;
      state.items.forEach(item => {
        item.events.forEach(event => {
          event[Object.keys(event)[0]].scripts = event[Object.keys(event)[0]].scripts.filter(item => item.templateId !== templateId);
        });
        return item;
      });
    },
    /**
     * イベントに記録されているスクリプト名を更新
     * @param {*} state 
     * @param {*} action 
     */
    updateEventScriptName(state, action) {
      const { scriptName, newScriptName } = action.payload;
      //全てのイベントを走査してスクリプト名を更新
      state.items.forEach(item => {
        item.events.forEach(event => {

          event[Object.keys(event)[0]].scripts = event[Object.keys(event)[0]].scripts.map(item => {
            if (item.scriptName === scriptName) {
              item.scriptName = newScriptName;
            }
            return item;
          });
        });
        return item;

      })
    },
    /**
     * 特定のスクリプトによって追加されたカスタムイベントをすべて削除する
     * @param {*} state 
     * @param {payload: { originScriptName: string }} action 
     */
    removeEventsByScript(state, action) {
      const { originScriptName } = action.payload;
      state.items.forEach(tag => {
        if (tag.events) {
          tag.events = tag.events.filter(event =>
            !(Object.values(event)[0].registerType === 'customScript' &&
              Object.values(event)[0].originScriptName === originScriptName)
          );
        }
      });
    },
  },
});

// stateからeventItemsを取得するセレクター
const selectEventItems = state => state.eventItems;

export const selectEventByTagName = createSelector(
  // 第一引数には入力セレクターの配列を渡す
  [selectEventItems, (state, tagName) => tagName],
  // 第二引数には出力セレクターの関数を渡す
  (eventItems, tagName) => {
    let element = eventItems.items.find(e => e.tagName === tagName);
    // エレメントが見つからなければ基本の配列を返す
    if (element === undefined || element === null) return [];
    // エレメントのattributesをコピーする
    let events = [...element.events];
    // 展開後のattributesを返す
    return events;
  });

/**
* state.eventItems.itemsの中身から、tagNameを無視してatteributesをすべて取得し、タグ名でサマリーするメソッド
*/
export const selectEventList = createSelector(
  selectEventItems,
  eventItems => {
    let items = eventItems.items;
    let events = items.map(item => item.events).flat();

    return events;
  });

export const selectEventByScriptName = createSelector(
  [selectEventItems, (state, scriptName) => scriptName],
  (eventItems, scriptName) => {
    let foundEvents = [];
    for (let item of eventItems.items) {
      for (let event of item.events) {
        if (event[Object.keys(event)[0]].scripts.some(script => script.scriptName === scriptName)) {
          foundEvents.push(event);
        }
      }
    }
    return foundEvents;
  }
);

export const { loadEventItemData, addNewTag, addEventToExistingTag, changeEventOrder,
  removeEventFromExistingTag, modifyEventName, addScriptToExistingTag, deleteEventScript,
  updateEventScriptName, deleteAllEventScript, removeEventsByScript, updateEventScripts
} = eventItemSlice.actions;
export default eventItemSlice.reducer;
